import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { notifications } from "data/actions";
import RaisedButton from "material-ui/RaisedButton";
import { Page, PageSection, PageBlock, RightDrawer } from "components/Page";
import Delete from "components/Buttons/Delete";
import Price from "components/Formaters/Price";
import Paragraphs from "components/Formaters/Paragraphs";

import Subheader from "material-ui/Subheader";
import Row from "components/Form/Row";
import MenuLink from "components/Navigation/MenuLink";

import Field from "components/Form/Field";
import { formatDateTime } from "osutil";

class NotificationPage extends Component {
  state = {};

  static contextTypes = {
    router: PropTypes.object
  };

  componentWillMount() {
    this.props.actions.fetchNotification(
      this.props.user.accountid,
      this.props.params.notificationid
    );
    this.props.actions.readNotification(
      this.props.user.accountid,
      this.props.params.notificationid
    );
  }

  unreadNotification = () => {
    this.props.actions.unreadNotification(
      this.props.user.accountid,
      this.props.params.notificationid
    );
  };

  readNotification = () => {
    this.props.actions.readNotification(
      this.props.user.accountid,
      this.props.params.notificationid
    );
  };

  deleteNotification = () => {
    this.props.actions.deleteNotification(
      this.props.user.accountid,
      this.props.params.notificationid
    );
    this.context.router.history.push(
      `/meddelanden`
    );
  };

  render() {
    const { notification } = this.props;
    if (!notification) {
      return null;
    }

    return [
      <RightDrawer key="brand_right">
        <PageBlock>
          <div className="row">
            Skickat:{" "}
            <b className="left_padded">
              {" "}
              {formatDateTime(notification.created)}
            </b>
          </div>
          <div className="row">
            Status:{" "}
            <b className="left_padded">
              {" "}
              {notification.read ? "Läst" : "Oläst"}
            </b>
          </div>
          <div className="row">
            {notification.read ? (
              <RaisedButton onClick={this.unreadNotification}>
                Markera som oläst
              </RaisedButton>
            ) : (
              <RaisedButton onClick={this.readNotification}>
                Markera som läst
              </RaisedButton>
            )}
          </div>
          <div className="row">
            <RaisedButton onClick={this.deleteNotification}>
              Radera
            </RaisedButton>
          </div>
        </PageBlock>
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        <Subheader>
          <MenuLink label="Meddelande" to="/meddelanden" />
          <span className="pathsep" />
          <MenuLink
            label={this.props.notification.subject}
            to={`/meddelande/${this.props.user.accountid}/${this.props.params
              .notificationid}`}
          />
        </Subheader>
        <PageSection label={this.props.notification.subject}>
          <Row>
            <Paragraphs text={this.props.notification.body} />
          </Row>
        </PageSection>
      </Page>
    ];
  }
}

function mapStateToProps(state, ownProps) {
  console.log("Notification", state.notifications.details);
  if (!state.notifications.details.data || !state.auth.user) {
    return { pending: true };
  }
  return {
    notification: state.notifications.details.data,
    user: ownProps.user,
    pending: state.notifications.details.pending
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators({ ...notifications }, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch)(NotificationPage);



// WEBPACK FOOTER //
// ./src/pages/notifications/NotificationPage.jsx